(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  console.warn(window.location.href.includes('pages'));

  if (window.location.href.includes('pages')) {

    const swiper2 = new Swiper('.swiper.slider-custom-collection', {
      // Optional parameters
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: '.custom-featured-collection-paginatin.swiper-pagination',
      },
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 730px
        600: {
          slidesPerView: 2,
          spaceBetween: 20,
          grid: {
            rows: 5,
            fill: 'row',
          },
        },
        650: {
          slidesPerView: 2,
          spaceBetween: 20,
          grid: {
            rows: 5,
            fill: 'row',
          },
        },
        950: {
          slidesPerView: 2,
          spaceBetween: 60,
          grid: {
            rows: 5,
            fill: 'row',
          },
        },
        1100: {
          slidesPerView: 4,
          spaceBetween: 40,
          grid: {
            rows: 5,
            fill: 'row',
          },
        },
        1400: {
          slidesPerView: 4,
          spaceBetween: 40,
          grid: {
            rows: 3,
            fill: 'row',
          },
        },
        2200: {
          slidesPerView: 4,
          spaceBetween: 60,
          grid: {
            rows: 3,
            fill: 'row',
          },
        },
      },
    });
  } else {
    const swiper2 = new Swiper('.swiper.slider-custom-collection', {
      // Optional parameters
      slidesPerView: 1,
      spaceBetween: 10,
      grabCursor: true,
      centeredSlides: true,
      centeredSlidesBounds: false,
      initialSlide: 0,
      pagination: {
        el: '.custom-featured-collection-paginatin.swiper-pagination',
      },
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 730px
        600: {
          slidesPerView: 2,
          spaceBetween: 20,
          initialSlide: 0,
        },
        650: {
          slidesPerView: 2,
          spaceBetween: 40,
          initialSlide: 0,
        },
        950: {
          slidesPerView: 2,
          spaceBetween: 90,
          initialSlide: 0,
        },
        1100: {
          slidesPerView: 3,
          spaceBetween: 40,
          initialSlide: 1,
        },
        1400: {
          slidesPerView: 4,
          spaceBetween: 30,
          initialSlide: 1,
        },
        2200: {
          slidesPerView: 5,
          spaceBetween: 60,
          initialSlide: 2,
        },
      },
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["packages"] && !Shopify.designMode) return;
  try {
    
  console.warn(window.location.href.includes('pages'));

  if (window.location.href.includes('pages')) {
    // const swiper = new Swiper('.swiper', {
    //   slidesPerView: 3,
    //   grid: {
    //     rows: 2,
    //     fill: "row",
    //   },
    //   spaceBetween: 32
    // });
    
    const swiper = new Swiper('.custom-new-container.swiper', {
      // Optional parameters
      slidesPerView: 1.25,
      spaceBetween: 2,
      centeredSlides: true,
      pagination: {
        el: '.custom-new-container-pagination.swiper-pagination',
      },
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 730px
        600: {
          slidesPerView: 1.25,
          spaceBetween: 60,
        },
        650: {
          slidesPerView: 2,
          spaceBetween: 20,
          centeredSlides: false,
          grid: {
            rows: 3,
            fill: 'row',
          },
        },
        950: {
          slidesPerView: 2,
          spaceBetween: 60,
          centeredSlides: false,
          grid: {
            rows: 3,
            fill: 'row',
          },
        },
        1100: {
          slidesPerView: 2,
          spaceBetween: 80,
          centeredSlides: false,
          grid: {
            rows: 3,
            fill: 'row',
          },
        },
        1300: {
          slidesPerView: 3,
          spaceBetween: 60,
          centeredSlides: false,
          grid: {
            rows: 2,
            fill: 'row',
          },
        },
        1400: {
          slidesPerView: 3,
          spaceBetween: 120,
          centeredSlides: false,
          grid: {
            rows: 2,
            fill: 'row',
          },
        },
        2200: {
          slidesPerView: 3,
          spaceBetween: 120,
          centeredSlides: false,
          grid: {
            rows: 2,
            fill: 'row',
          },
        },
      },
    });
  } else {
    const swiper = new Swiper('.custom-new-container.swiper', {
      // Optional parameters
      slidesPerView: 1.25,
      spaceBetween: 2,
      grabCursor: true,
      centeredSlides: true,
      centeredSlidesBounds: false,
      initialSlide: 0,
      pagination: {
        el: '.custom-new-container-pagination.swiper-pagination',
      },
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 730px
        650: {
          slidesPerView: 2,
          spaceBetween: 0,
          initialSlide: 0,
        },
        950: {
          slidesPerView: 2,
          spaceBetween: 50,
          initialSlide: 0,
        },
        1100: {
          slidesPerView: 3,
          spaceBetween: 20,
          initialSlide: 1,
        },
        1400: {
          slidesPerView: 4,
          spaceBetween: 10,
          initialSlide: 1,
        },
        2200: {
          slidesPerView: 5,
          spaceBetween: 60,
          initialSlide: 2,
        },
      },
    });
  }

  } catch(e) { console.error(e); }
})();
})();
